import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";

interface ScanToOrderCartHeaderProps {
  titleId: string;
}

export const ScanToOrderCartHeader = ({
  titleId,
}: ScanToOrderCartHeaderProps) => {
  const t = useTranslations("ScanToOrderCartHeader");
  return (
    <div
      data-testid={applyDataTestId(pom.scanToOrder.scanToOrderCartHeader)}
      className="min-h-14 justify-between px-4 flex shadow-md"
    >
      <h2 id={titleId} tabIndex={-1} className="text-xl font-medium pt-[15px]">
        {t("yourCart")}
      </h2>
    </div>
  );
};
